import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Users18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.5 8.25C6.99783 8.25 8.25 6.99783 8.25 5.5C8.25 4.00217 6.99783 2.75 5.5 2.75C4.00217 2.75 2.75 4.00217 2.75 5.5C2.75 6.99783 4.00217 8.25 5.5 8.25ZM5.5 4.25C6.18083 4.25 6.75 4.81917 6.75 5.5C6.75 6.18083 6.18083 6.75 5.5 6.75C4.81917 6.75 4.25 6.18083 4.25 5.5C4.25 4.81917 4.81917 4.25 5.5 4.25Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 4C10.366 4 9 5.366 9 7C9 8.634 10.366 10 12 10C13.634 10 15 8.634 15 7C15 5.366 13.634 4 12 4ZM12 5.5C12.817 5.5 13.5 6.183 13.5 7C13.5 7.817 12.817 8.5 12 8.5C11.183 8.5 10.5 7.817 10.5 7C10.5 6.183 11.183 5.5 12 5.5Z'
      fill='currentColor'
    />
    <path
      d='M6.25 14C6.25 12.4812 7.48122 11.25 9 11.25H15C16.5188 11.25 17.75 12.4812 17.75 14V16H16.25V14C16.25 13.3096 15.6904 12.75 15 12.75H9C8.30964 12.75 7.75 13.3096 7.75 14V16H6.25V14Z'
      fill='currentColor'
    />
    <path
      d='M3 9.25C1.48122 9.25 0.25 10.4812 0.25 12V14H1.75V12C1.75 11.3096 2.30964 10.75 3 10.75H8V9.25H3Z'
      fill='currentColor'
    />
  </Svg>
);

Users18.displayName = 'Users18';
export default Users18;
